<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title">API's List</h3>

            <div class="card-tools">
                <div class="input-group input-group-sm" style="width: 200px;">
                    <input type="search" name="table_search" class="form-control float-right" placeholder="Search">
                    <div class="input-group-append">
                        <button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button>
                    </div>
                    <div class="btn-group">
                        <button type="button" class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown" data-offset="-52" aria-expanded="true">
                            Types
                            <i class="fas fa-bars"></i>
                        </button>
                        <div class="dropdown-menu" role="menu">
                            <a href="#" class="dropdown-item" @click="loadAPIType('all')">
                               All
                            </a>
                            <a href="#" class="dropdown-item" v-for="type in types" :key="type.id" @click="loadAPIType(type)">
                               {{ type.shortname }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body table-responsive p-0">
            <div v-if="!hasSelected" class="text-center text-muted p-4">
                <i class="fas fa-arrow-up mb-2" style="font-size: 1.5rem;"></i>
                <p>Select a type from the <strong>Types</strong> dropdown to load APIs</p>
            </div>
            <div v-else-if="apis.length === 0" class="text-center text-muted p-4">
                <p>No APIs found for this type</p>
            </div>
            <table v-else class="table table-hover">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="api in apis" :key="api.id" v-animate-css="'slideInLeft'" @click="loadAPI(api)" style="cursor: pointer;">
                        <td>{{ api.name }}</td>
                        <td>{{ api.type }}</td>
                        <td class="text-center">
                            <div class="btn-group">
                                <button class="btn btn-default btn-sm" @click.stop="loadAPI(api)">
                                    <i class="fa fa-edit"></i> Edit
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="overlay" v-if="!isLoaded">
            <point-spinner />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        apis: {
          required: true,
          type: Array
        },
        types: {
            required: true,
          type: Array
        },
        isLoaded: {
          required: false,
          type: Boolean
        },
        selectedType: {
          required: false,
          type: String
        },
    },
    computed: {
        hasSelected: function() {
            return this.selectedType && this.selectedType !== 'all' || this.apis.length > 0
        }
    },
    methods: {
        loadAPIType: function(type) {
            this.$emit('typeChanged', type)
        },
        loadAPI: function(api) {
            this.$emit('apiChanged', api)
        },
    },
}
</script>

<style scoped>

</style>
